module.exports = __webpack_public_path__ + "img/L_JS.1c716f36.png";